import { Component, OnInit } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'

@Component({
    templateUrl: './leave-meeting-prompt.component.html',
    styleUrls: ['./modal.css'],
    standalone: true,
    imports: [FaIconComponent],
})
export class LeaveMeetingPromptComponent implements OnInit {
    faQuestionCircle = faQuestionCircle

    constructor(private _activeModal: NgbActiveModal) {}

    public title = 'Leave the meeting?'
    public message = ''
    public targetUrl = ''
    public isLead = false

    ngOnInit(): void {
        this.message = this.isLead
            ? 'You are leading this meeting. Leaving will disconnect you and may hand leadership to another attendee. Open the link in a new tab to keep leading.'
            : 'You are in a live meeting. Leaving will disconnect you from the session. Open the link in a new tab to stay in the meeting.'
    }

    openedInNewTab(): void {
        this._activeModal.close('newTab')
    }

    leave(): void {
        this._activeModal.close('leave')
    }

    stay(): void {
        this._activeModal.dismiss('cancel')
    }
}
